import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { NaceService } from './nace.service';

const service = new NaceService();

export interface NaceState {}

const NaceStore: Module<NaceState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async getNaces(context, query?: LocationQuery) {
         const response = await service.getNaces(query);
         return response;
      },
   },
};

export default NaceStore;
